import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Bio = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 81 139.58">
  <G fill={color}>
    <Path d="M80.9,2.78c-.32-1.28-1.4-2.23-2.71-2.38-11.42-1.34-35.02.4-53.22,10.7C7.76,20.82-8.09,35.5,4.58,70.38c-2.8,6.4-3.51,10.42-3.57,10.82-.27,1.72.89,3.34,2.62,3.63.17.03.35.05.51.05,1.53,0,2.87-1.1,3.13-2.65.04-.23,4.24-23.38,35.11-49.38,1.34-1.13,1.51-3.13.39-4.47-1.13-1.34-3.13-1.51-4.47-.38-15.2,12.8-24.27,24.92-29.66,34.36C.75,34.93,13.83,24.69,28.1,16.61c13.49-7.63,30.64-10.17,42.13-10.25-4.19,5.46-5.47,12.22-7.17,21.24-.69,3.63-.77,7.24-.84,10.73-.19,8.55-.35,15.93-8.48,23.35-11.43,10.43-31.13,7.53-31.41,7.49-1.72-.26-3.36.91-3.62,2.64-.27,1.73.9,3.36,2.64,3.63.33.06,3.31.5,7.63.5,7.86,0,20.18-1.49,29.05-9.58,10.14-9.25,10.36-19.15,10.54-27.89.08-3.38.15-6.58.74-9.73,2.16-11.43,3.34-17.73,10.33-22.58,1.08-.75,1.59-2.09,1.27-3.38"/>
    <Path d="M47.94,129.74c0,3.17.8,5.6,2.4,7.29,1.6,1.7,3.91,2.55,6.93,2.55s5.33-.85,6.93-2.55c1.6-1.69,2.4-4.13,2.4-7.29v-20.35c0-3.17-.8-5.6-2.4-7.3-1.61-1.69-3.91-2.54-6.93-2.54s-5.33.85-6.93,2.54c-1.61,1.7-2.4,4.13-2.4,7.3v20.35ZM54.09,108.99c0-1.42.28-2.41.86-2.99.58-.57,1.35-.86,2.32-.86s1.74.29,2.32.86c.58.58.87,1.58.87,2.99v21.14c0,1.42-.29,2.41-.87,2.99-.58.57-1.35.86-2.32.86s-1.74-.29-2.32-.86c-.58-.58-.86-1.58-.86-2.99v-21.14ZM37.72,139.13h6.15v-39.14h-6.15v39.14ZM24,105.58c1.08,0,1.87.32,2.37.95s.76,1.66.76,3.08v2.18c0,1.57-.33,2.65-.98,3.24-.66.59-1.56.89-2.71.89h-2.4v-10.34h2.96ZM23.78,121.52c1.42,0,2.43.34,3.05,1.01.62.67.93,1.92.93,3.75v3.41c0,1.45-.27,2.46-.81,3.02-.54.56-1.33.84-2.37.84h-3.52v-12.02h2.74ZM14.89,99.99v39.14h9.67c3.1,0,5.42-.79,6.99-2.38,1.57-1.58,2.35-3.88,2.35-6.9v-3.19c0-2.09-.35-3.85-1.04-5.29-.69-1.43-1.87-2.47-3.55-3.1,1.38-.64,2.38-1.6,3.02-2.91s.95-2.96.95-4.98v-1.4c0-3.02-.72-5.28-2.16-6.77-1.43-1.49-3.75-2.24-6.96-2.24h-9.28Z"/>
  </G>
</Svg>
);
};

export default Bio;
